const theme = {
  brand_color: "#002233",
};

export default theme;
